import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { useApp } from './lib/store'
import { startSync } from './lib/sync'
import { HomeScreen } from './screens/Home'
import { TablesScreen } from './screens/Tables'
import { OrderScreen } from './screens/Order'
import { PayScreen } from './screens/Pay'
import { ExpenseScreen } from './screens/Expense'
import { ReportScreen } from './screens/Report'
import { SettingsScreen } from './screens/Settings'
import { BankSettingsScreen } from './screens/BankSettings'
import { PrinterSettingsScreen } from './screens/PrinterSettings'
import { ProductsScreen } from './screens/Products'
import { ShiftScreen } from './screens/Shift'
import { HistoryScreen } from './screens/History'
import { ShopSettingsScreen } from './screens/ShopSettings'
import { StaffScreen } from './screens/Staff'
import { MenuScanScreen } from './screens/MenuScan'
import { BillingScreen } from './screens/Billing'
import { LoginScreen } from './screens/Login'
import { UpdateBanner } from './components/UpdateBanner'

export function App() {
  const ready = useApp((s) => s.ready)
  const session = useApp((s) => s.session)
  const boot = useApp((s) => s.boot)
  const toast = useApp((s) => s.toast)
  const storageBroken = useApp((s) => s.storageBroken)

  useEffect(() => {
    void boot()
  }, [boot])

  useEffect(() => {
    if (!session) return
    return startSync()
  }, [session])

  // Chưa đọc xong dữ liệu trên máy thì để trống — chớp một cái là xong,
  // hiện vòng xoay tải chỉ làm màn hình giật.
  if (!ready) return <div className="screen" />

  return (
    <BrowserRouter>
      {storageBroken && (
        <div className="storage-warning" role="alert">
          Máy này không cho phép lưu dữ liệu, nên app <b>không bán được khi mất mạng</b>. Nếu đang
          dùng cửa sổ ẩn danh thì mở lại bằng cửa sổ thường.
        </div>
      )}

      {!session ? (
        <LoginScreen />
      ) : (
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/tables" element={<TablesScreen />} />
          <Route path="/order/:orderId" element={<OrderScreen />} />
          <Route path="/pay/:orderId" element={<PayScreen />} />
          <Route path="/expense" element={<ExpenseScreen />} />
          <Route path="/report" element={<ReportScreen />} />
          <Route path="/shift" element={<ShiftScreen />} />
          <Route path="/history" element={<HistoryScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/settings/shop" element={<ShopSettingsScreen />} />
          <Route path="/settings/staff" element={<StaffScreen />} />
          <Route path="/settings/bank" element={<BankSettingsScreen />} />
          <Route path="/settings/printer" element={<PrinterSettingsScreen />} />
          <Route path="/settings/products" element={<ProductsScreen />} />
          <Route path="/settings/products/scan" element={<MenuScanScreen />} />
          <Route path="/settings/billing" element={<BillingScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}

      <UpdateBanner />

      {toast && (
        <div className="toast" role="status">
          {toast}
        </div>
      )}
    </BrowserRouter>
  )
}
